//Custom components
import { NumericFormat as NumberFormat } from 'react-number-format';
import StatCard from '../../../UI/Card/StatCard';

const TotalProposedUnitsWidget = ({ count }: { count: number }) => {
  return <StatCard title='Total Proposed Units' stat={<NumberFormat value={count} displayType='text' thousandSeparator={true} />} />;
};

export default TotalProposedUnitsWidget;
